import { API_REFERENCE } from '../utilities/constant_api';
const radioRepersentative = '#representative';
const radioPatient = '#patient';
const errorClass = 'error-msg-textbox';
const repersentativeField = '.repersentative_specific_fields';
const getMarketConsentUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.patientMarketFlow.marketingConsentUrl}`;
const savePatientId = '#savepatient';
const reasonPatientId = '#reasonPatient';
const patientOption = '.patientConsent_form_optionSelection';
const otherReason = '#otherReasonPatient';
const patientSignature = '#patientConsentForm_Signature';
const patientRelationship = '#patientConsentForm_relationship';
let errorFlag = true;
const otherReasonsField = '.otherReasons';
const patientFormId = '#patientConsentForm';
const requiredField = '.validCommon';
const patientReasonId = '#reasonPatient-button';
const clsPatientAgree = '#patientConsentAgree';
const registerationContainer = '.registration_container';
const clsHidden = 'hidden';
let marketingConsentDoubleClick = true;

(function($, doc) {
  function patientRadioCheck() {
    $(requiredField).val('');
    $(patientSignature).removeClass('success-msg-textbox');
    $('#patientConsentContinue').attr('disabled', 'disabled');
    const isPatient = $(radioPatient).is(':checked');
    $(repersentativeField).toggleClass(clsHidden, isPatient);
    $(requiredField)
      .next()
      .addClass(clsHidden);
    $(requiredField).removeClass(errorClass);
  }

  function repersentativeRadioCheck() {
    $(reasonPatientId).selectmenu();
    $(patientSignature).removeClass('success-msg-textbox');
    $('#patientConsentContinue').attr('disabled', 'disabled');
    $(requiredField).val('');
    $(reasonPatientId).val('');
    $(reasonPatientId).selectmenu('refresh');
    $(otherReason).hide();
    $(otherReasonsField).removeClass('validCommon');
    const isRepersentative = $(radioRepersentative).is(':checked');
    $(repersentativeField).toggleClass(clsHidden, !isRepersentative);
    $(requiredField)
      .next()
      .addClass(clsHidden);
    $(requiredField).removeClass(errorClass);
    $(patientReasonId)
      .next()
      .addClass(clsHidden);
    $(patientReasonId).removeClass(errorClass);
  }

  function reasonPatientChange() {
    errorFlag = true;
    const selecteditemvalue = $(this).val();
    if (
      selecteditemvalue === 'other' &&
      selecteditemvalue !== '' &&
      selecteditemvalue
    ) {
      $('.otherReason')
        .next()
        .addClass(clsHidden);
      $(otherReason).removeClass(errorClass);
      $(otherReason).show();
      $(otherReasonsField).addClass('validCommon');
    } else {
      $(otherReason).hide();
      $(otherReasonsField).removeClass('validCommon');
    }
    $(patientReasonId)
      .next()
      .addClass(clsHidden);
    $(patientReasonId).removeClass(errorClass);
  }

  function formSubmission(agreed) {
    const getradioselected = $("input[name='usertype']:checked").val();
    const patientForm = $(savePatientId).closest(patientFormId);
    const getPatientSign = $(patientSignature).val();
    const getRelationship = $(patientRelationship).val();
    const getReason = $(reasonPatientId).val();
    const getOtherReason = $(otherReasonsField).val();
    $('#patientConsentField').val(agreed);
    $('#patientSignature').val(getPatientSign);
    $('#representativeRelationship').val(getRelationship);
    $('#representativeReason').val(getReason);
    $('#patientSelected').val(getradioselected);
    $('#representativeOtherReason').val(getOtherReason);
    patientForm.submit();
  }

  function applyChanges() {
    const isPatient = $(radioPatient).is(':checked');
      if (isPatient) {
        if ($(patientSignature).val().trim() === '' || $(patientSignature).val().trim().length < 2) {
          errorFlag = false;
          $(patientSignature)
            .next()
            .removeClass(clsHidden);
          $(patientSignature).addClass(errorClass);
        }
      } else {
        if ($(patientSignature).val().trim() === '' || $(patientSignature).val().trim().length < 2) {
          errorFlag = false;
          $(patientSignature)
            .next()
            .removeClass(clsHidden);
          $(patientSignature).addClass(errorClass);
        }
        if ($(patientRelationship).val().trim() === '') {
          errorFlag = false;
          $(patientRelationship)
            .next()
            .removeClass(clsHidden);
          $(patientRelationship).addClass(errorClass);
        }
        if (
          $(reasonPatientId).val() === '' ||
          $(reasonPatientId).val() === null
        ) {
          errorFlag = false;
          $(patientReasonId)
            .next()
            .removeClass(clsHidden);
          $(patientReasonId).addClass(errorClass);
        }
        if ($(otherReasonsField).val().trim() === '') {
          if ($(otherReasonsField).hasClass('validCommon')) {
            errorFlag = false;
            $(otherReasonsField)
              .next()
              .removeClass(clsHidden);
            $(otherReasonsField).addClass(errorClass);
          }
        }
      }
  }

  function checkValidationPatient() {
    const agreed = $(clsPatientAgree).prop('checked');
      applyChanges();
      if (errorFlag) {
        if (location.pathname.indexOf('patientconsent') > -1) {
          formSubmission(agreed);
        } else {
          openMarketingPage(agreed);
        }
      }
  }

  function openMarketingPage() {
    if (location.pathname.indexOf('register') > -1) {
      if (!marketingConsentDoubleClick) return false;
      marketingConsentDoubleClick = false;
      const passwordForm = $('.step2_form').serialize();
      const regForm = $('.registration-form').serialize();
      const existingForm = $('.existingUser_generalInfo_form').serialize();
      let marketingConsentData = null;
      $.ajax({
        type: 'POST',
        url: getMarketConsentUrl,
        data: regForm + '&' + passwordForm + '&' + existingForm,
        success: function(response) {
          marketingConsentDoubleClick = true;
          marketingConsentData = ACC.sanitizer.sanitizeHtmlDeeply(response);
          $('.patient_consent_inner').hide();
          $(registerationContainer).append(marketingConsentData);
          $(window).scrollTop(0);
          $('#marketingconsent-version-number').val(
            $('.marketing-consent-info .tc-pdf-version').text()
          );
        }
      }).fail(function() {
        marketingConsentDoubleClick = true;
        console.log('not submitted');
      });
    }
  }

  function backFromMarketingConsent() {
    $('.patient_consent_inner').show();
    $('.marketing_consent_inner').remove();
    $(window).scrollTop(0);
  }

  function validateInput(e) {
    errorFlag = true;
    e.stopImmediatePropagation();
    $(this)
      .next()
      .addClass(clsHidden);
    $(this).removeClass(errorClass);
    if ($(this).val().trim() === '') {
      errorFlag = false;
      $(this)
        .next()
        .removeClass(clsHidden);
      $(this).addClass(errorClass);
    }
  }

  function backToPreviousPage() {
    window.history.back();
    if (location.pathname.indexOf('checkout') < 0) {
      $(window).scrollTop(0);
    }
  }

  function init() {
    $(reasonPatientId).selectmenu();
    $(document).on('selectmenuchange', reasonPatientId, reasonPatientChange);
    $(document).on('change', radioPatient, patientRadioCheck);
    $(document).on('change', radioRepersentative, repersentativeRadioCheck);
    $(document).on('click', savePatientId, checkValidationPatient);
    $(document).on('click', '.patientCancel', backToPreviousPage);
    $(document).on(
      'click',
      '.marketing-consent-back-text',
      backFromMarketingConsent
    );
    $(document).on('input', requiredField, validateInput);
  }
  init();
})(jQuery, document);
